import { DateTime } from '@calendly/datetime'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { isEnterpriseSelector } from 'features/billing'
import { smsCustomizationRestrictedSelector } from 'selectors/current_organization'

const SMS_CUSTOMIZATION_RESTRICTION_DAYS = 60

export const useIsSmsCustomizationRestricted = (currentUser) => {
  const isEnterprise = useSelector(isEnterpriseSelector)
  const backendSmsCustomizationRestricted = useSelector(smsCustomizationRestrictedSelector)

  return useMemo(() => {
    if (typeof backendSmsCustomizationRestricted === 'boolean') {
      return backendSmsCustomizationRestricted
    }

    if (isEnterprise) return false
    if (!currentUser?.created_at) return false

    const cutoff = DateTime.now().startOf('day').minus({ days: SMS_CUSTOMIZATION_RESTRICTION_DAYS })
    const createdAt = DateTime.fromISO(currentUser.created_at).startOf('day')

    return cutoff < createdAt
  }, [backendSmsCustomizationRestricted, currentUser, isEnterprise])
}
